import { useState } from "react";
import http from "../services/http";
import "../scss/login.scss";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [apiError, setApiError] = useState("");

    const validate = (): boolean => {
        if (!email.trim()) {
            setEmailError("Email harus diisi");
            return false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError("Email tidak valid");
            return false;
        }
        setEmailError("");
        return true;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        setApiError("");

        try {
            await http.post("auth/forgot-password", { email });
            setSubmitted(true);
        } catch (error: any) {
            setApiError(
                error.response?.data?.message || "Gagal mengirim. Silakan coba lagi."
            );
        } finally {
            setLoading(false);
        }
    };

    const isFormValid = email.trim() && !emailError;

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Lupa Password</h1>
                    <p>Masukkan email Anda untuk menerima link reset password</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {apiError && (
                        <div className="alert alert-error">{apiError}</div>
                    )}

                    {submitted ? (
                        <div className="alert alert-success">
                            <p style={{ marginBottom: 0 }}>
                                Jika email terdaftar, link reset password telah dikirim ke <strong>{email}</strong>.
                                Silakan cek inbox atau folder spam Anda.
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className="form-group">
                                <label htmlFor="email">Email *</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        if (emailError) setEmailError("");
                                    }}
                                    placeholder="Masukkan email Anda"
                                    className={`form-input ${emailError ? "error" : ""}`}
                                />
                                {emailError && (
                                    <span className="error-message">{emailError}</span>
                                )}
                            </div>

                            <button
                                type="submit"
                                className={`submit-button ${isFormValid && !loading ? "active" : "disabled"}`}
                                disabled={!isFormValid || loading}
                            >
                                {loading ? "Mengirim..." : "Kirim Link Reset"}
                            </button>
                        </>
                    )}

                    <p className="register-link">
                        <a href="/login">← Kembali ke Login</a>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
